import { Media } from './media';
import { Publication } from './publication';
import { Config } from '../../config/config';
import { Img } from './img';
import { plainToClass } from 'class-transformer';
import { Categorie } from './categorie';

export class Projet extends Publication {

    
    // parent: number;
    categories: Categorie[];
    images: Img[];

    constructor() {
        super();
    }

    /* get linkFichier(): string {

        if( this.fichier !== null && this.fichier !== undefined && this.fichier.url !== null && this.fichier.url !== undefined)
        return  Config.urlserveur + this.fichier.url;
        else
        return null;
    } */

    /* get imagesPlainToClass(): Img[] {

        if( this.images !== null && this.images !== undefined)
        return plainToClass( Img, this.images);
        else
        return [];
    } */
   

}
